import type { SharePointResourceTokenPrefetchState } from '../Schema/SharePointResourceTokenPrefetchState';
import { createStore } from 'owa-satcheljs';

export interface SharePointResourceTokenPrefetchStateStore {
    tokenStatusPerResource: Map<string, SharePointResourceTokenPrefetchState>;
}

export const getInitialState = (): SharePointResourceTokenPrefetchStateStore => {
    return {
        tokenStatusPerResource: new Map<string, SharePointResourceTokenPrefetchState>(),
    };
};

// tokenStatusPerResource is a map from keys (sharepoint resource URL) to values (SharePointResourceTokenPrefetchState)
export const getSharePointResourceTokenPrefetchStateStore = createStore(
    'sharePointResourceTokenPrefetchStateStore',
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getInitialState called at module scope is not allowed. This may cause unwanted side effects. */
    getInitialState()
);
